import { COMPLETE_ROUTE, CREATE_ROUTE, DROPERS_DROPDOWN, EDIT_ROUTE, LIST_ROUTE, PRODUCT_ROUTE_LIST, STORES_DROPDOWN, VIEW_ROUTE } from "./types";


export const createRouteAction = (data, onSuccess, onError) => {
    return {
        type: CREATE_ROUTE,
        data,
        onSuccess,
        onError,
    };
};


export const editRouteAction = (data, onSuccess, onError) => {
    return {
        type: EDIT_ROUTE,
        data,
        onSuccess,
        onError,
    };
};

export const listRouteAction = (data, onSuccess, onError) => {
    return {
        type: LIST_ROUTE,
        data,
        onSuccess,
        onError,
    };
};

export const viewRouteAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_ROUTE,
        data,
        onSuccess,
        onError,
    };
};

export const productsRouteListAction = (data, onSuccess, onError) => {
    return {
        type: PRODUCT_ROUTE_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const completeRouteAction = (data, onSuccess, onError) => {
    return {
        type: COMPLETE_ROUTE,
        data,
        onSuccess,
        onError,
    };
};

export const dropersDropdownAction = (data, onSuccess, onError) => {
    return {
        type: DROPERS_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};

export const storesDropdownAction = (data, onSuccess, onError) => {
    return {
        type: STORES_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};
